
import { Spinner } from 'react-bootstrap';


export default function Loader() {
    return (
        <div className="d-flex justify-content-center align-items-center"
            style={{ position: 'fixed', top: 0, left: 100, width: '100vw', height: '100vh' }}>
            <Spinner animation="border" role="status" style={{ color: 'var(--primary-loader)' }} />
        </div>
    )
}